import {memo} from "react";

import Image from "react-bootstrap/Image";
import {MyTextInput} from "../../common/formikCommon/MyFieldsBS"

export const ImageMemo = memo(Image)
export const MyTextInputMemo = memo(MyTextInput)

